import axios from "@/plugins/axios";

// Komposisi 2-Digit Perbelanjaan Penggunaan & Bukan Penggunaan Isi Rumah Bulanan.
// Rows = COICOP 2-digit divisions (+ total rows); each strata carries Purata (RM)
// and Peratus (%). Latest year computed from `lampiran_hid_perbelanjaan`; previous
// years dash. `data.rows` = [{ kod, keterangan, isTotal, strata:{ Bandar/'Luar
// Bandar'/Jumlah:{ year:{rm,pct}|null } } }]. Default Malaysia; filter by negeri.
export default class perbelanjaanKomposisiServices {
  // params: { NG?, P (csv pusingan), S ("1"|"2"|"3"), W ("W"|"TW") }
  async getPerbelanjaanKomposisi(params = {}) {
    const res = await axios.get(
      `${process.env.VUE_APP_API_URL}/JadualAwalan/getPerbelanjaanKomposisiLampiran`,
      { params }
    );
    return (res.data && res.data.data) || {};
  }
}
